
<h1 mat-dialog-title>
   <div class="flex">
  <span class="parraTittle">{{ 'k004410' | translate }}</span>
  <!-- Token: Account statement history -->
  <div mat-button mat-dialog-close class="btoCLoseModal"><span>×</span></div>
  </div>
</h1>

<div mat-dialog-content>
  <p class="parrafReport">{{ 'k004411' | translate }}</p> <!-- Token: View and download your latest Account Statement. -->

  <div class="tech-form-standar" *ngIf="showAccountStatementDocuments; else elseBlock">
    <mat-form-field  class="col-xs-12 col-lg-12">
      <mat-label>{{ 'k000332' | translate }}</mat-label> <!-- Token: Seleccione Archivo -->
      <mat-select
        class="tech-mat-selectCampaign"
        (selectionChange)="onDocumentChange($event)"
        [(value)]="selectedDocumentId"
        >
        <mat-option
          *ngFor="let dataItem of arrdata"
          [value]="dataItem.Id">
          {{ dataItem.Description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>
<div mat-dialog-actions align="end" *ngIf="showAccountStatementDocuments">
  <button mat-button mat-dialog-close class="buttonPortal cancel mb-3">
    {{ 'k002311' | translate }} <!-- Token: cancel -->
  </button>
  <button
    class="buttonPortal mb-3 ml-2"
    [mat-dialog-close]="selectedDocument"
    mat-button
    cdkFocusInitial
  >
  {{ 'k000951' | translate }}  <!-- Token: Download -->
  </button>
</div>

<ng-template #elseBlock>
<div class="tech-form-standar espacio testElseBlock" >
    <span>{{ 'k004412' | translate }}</span>
    <!-- Token: No account statements were found in your history. -->
  </div>
  </ng-template>
